import {
  GETALLPLATFORM_SUCCESS,
  GETALLPLATFORM_FAIL,
} from "../actionTypes/index";
const initialState = {
  platformData: null,
};
export default function getAllPlatformReducer(state = initialState, action) {
  switch (action.type) {
    case GETALLPLATFORM_SUCCESS:
      return {
        ...state,
        platformData: action.payload.user,
      };
    case GETALLPLATFORM_FAIL:
      return {
        ...state,
        platformData: null,
      };
    default:
      return state;
  }
}
